import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import InfoForm from "@/pages/InfoForm";
import Dashboard from "@/pages/Dashboard";
import Checkout from "@/pages/Checkout";
import CommercialGate from "@/components/CommercialGate";
import { Toaster } from "@/components/ui/sonner";
import { LocaleProvider } from "@/i18n";

function App() {
  return (
    <LocaleProvider>
      <div className="App" data-testid="app-root">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/form" element={<CommercialGate><InfoForm /></CommercialGate>} />
            <Route path="/dashboard" element={<CommercialGate allowConsumed><Dashboard /></CommercialGate>} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#111A36",
              color: "#F7E8C2",
              border: "1px solid rgba(212,175,55,0.35)",
            },
          }}
        />
      </div>
    </LocaleProvider>
  );
}

export default App;
